const spacingCurves: SpacingCurveProps = {
  component: {
    basic: (prop: any) => ({ [prop]: { zero: 0, medium: 2 } }),
    deci: (prop: any) => ({ [prop]: { zero: 12, medium: 16 } }),
    regular: (prop: any) => ({ [prop]: { zero: 16, medium: 24 } }),
    hecto: (prop: any) => ({ [prop]: { zero: 24, medium: 32 } }),
    kilo: (prop: any) => ({ [prop]: { zero: 32, medium: 40 } }),
    mega: (prop: any) => ({ [prop]: { zero: 40, large: 48 } }),
    giga: (prop: any) => ({ [prop]: { zero: 40, medium: 48, large: 56 } }),
    tera: (prop: any) => ({ [prop]: { zero: 48, medium: 56, large: 64 } }),
    peta: (prop: any) => ({ [prop]: { zero: 64, large: 80 } }),
    exa: (prop: any) => ({ [prop]: { zero: 64, large: 80, ultra: 120 } }),
  },
};

export interface SpacingCurveProps {
  [key: string]: any;
}

export default spacingCurves;
